<template>
  <button type="button" class="flex center-xs middle-xs">
    <svg
      viewBox="0 0 24 24"
      style="
        display: inline-block;
        color: rgba(0, 0, 0, 0.870588);
        fill: currentcolor;
        height: 24px;
        width: 24px;
        transition: all 450ms ease 0ms;
        user-select: none;
      "
    >
      <path
        style="transform: translate3d(-1px, 1px, 0)"
        d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"
      />
    </svg>
  </button>
</template>

<script setup lang="ts"></script>
